/**
 * Z-Index System
 * Centralized z-index values for consistent layering
 */

export const zIndex = {
  modalBackdrop: 50,
  navbar: 100,
  modalContainer: 300,
  modalBackButton: 301,
  // Base + step for the shared modal stack. A modal at stack index N takes the
  // band starting at modalLayerBase + N*modalLayerStep; the one shared backdrop
  // slots just below the topmost modal's content. The step is small so even
  // several stacked modals stay below `popover` (450), keeping popovers opened
  // inside a modal above it.
  modalLayerBase: 300,
  modalLayerStep: 10,
  popover: 450,
  dropdown: 500,
  // Popovers/overlays that must render above standard modals (e.g. the
  // Time Machine overlay, date popovers escaping a modal stacking context).
  popoverAboveModal: 10000,
  // The one app-wide auth gate. It is raised from ordinary pages AND from
  // surfaces that already sit above modals (the teams-gallery deck at 900, its
  // expanded team overlay at 1000, and stacked overlays at popoverAboveModal),
  // so it has to clear all of them — a sign-in prompt rendered behind the thing
  // that asked for it is a dead end for the user. The provider wraps it in a
  // stacking context at this value, which contains Cmodal's own 50/300 layers.
  authModal: 10001,
  // The general message modal — the single highest-priority overlay in the app.
  // Must sit above EVERYTHING, including popoverAboveModal and authModal, so
  // critical errors/messages are never occluded.
  globalMessage: 10002,
} as const;

export type ZIndex = typeof zIndex;

